import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-sidenav-logo',
    templateUrl: './sidenav-logo.component.html',
    styleUrls: ['./sidenav-logo.component.scss'],
    standalone: false
})
export class SidenavLogoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
